module.exports = __webpack_public_path__ + "img/rooms.da6e783b.svg";